;globalThis["_sentryNextJsVersion"] = "16.4.2";import * as Sentry from "@sentry/nextjs";
import { scrubSentryBreadcrumb, scrubSentryEvent } from "@/lib/platform/observability/pii-scrub";
import { publicSentryDsn } from "@/lib/platform/public-config";

Sentry.init({
    dsn: publicSentryDsn,
    enabled: process.env.NODE_ENV === "production",
    tracesSampleRate: 0.2,
    release: process.env.SENTRY_RELEASE || process.env.npm_package_version,
    environment: process.env.NODE_ENV,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.breadcrumbsIntegration({
            console: true,
        }),
    ],
    ignoreErrors: [
        "ResizeObserver loop",
        "Network request failed",
        "Load failed",
    ],
    beforeSend: scrubSentryEvent,
    beforeBreadcrumb: scrubSentryBreadcrumb,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
